import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getQRCode = async (params: object) => {
  return await GET({ url: Api.getQRCode, params, showError: false })
}
export const queryCourierSurplusCount = async (params: object) => {
  return await GET({ url: Api.queryCourierSurplusCount, params, showError: false })
}
